import React, { Component } from "react";
import CtDtp from "./CustomTool/CtDtp";
import { Grid, Box } from "@mui/material";
import Progress from "./CustomTool/Progress";
import { getRowColData } from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";
import CtTxt from "./CustomTool/CtTxt";
import { Delete, Edit } from "@mui/icons-material";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { type } from "@testing-library/user-event/dist/type";
class ProductionEntry2 extends Component {
  state = {
    dataLoadStatus: true,
    formData: {
      dtpDate: get_YMD_from_SYS(new Date()),
      lblProductionNo: 0,
      cmbTitle: "",
    },
    rowsCount: 0,
    rowsPerPage: 50,

    columns2: [
      { id: "Action", label: "" },
      {
        id: "vac_itemname",
        label: "Item Name",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 200,
          width: 200,
          items: [
            { vac_itemname: "Magnesium Carbonate Lump" },
            { vac_itemname: "Packing bag" },
            { vac_itemname: "Soda Ash Light" },
            { vac_itemname: "Bittern" },
            { vac_itemname: "Water" },
            { vac_itemname: "Fire Wood" },
          ],
          colID: "vac_itemname",
        },
      },
      {
        id: "vac_packing",
        label: "Packing",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          items: [
            { vac_packing: "KG" },
            { vac_packing: "L" },
            { vac_packing: "CR" },
            { vac_packing: "Nos" },
          ],
          colID: "vac_packing",
        },
      },
      {
        id: "txt_qty",
        label: "Qty",
        type: "CtTxtAmt",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          colID: "txt_qty",
        },
      },
    ],
    rows2: [
      {
        vac_itemname: "Magnesium Carbonate Lump",
        vac_packing: "KG",
        txt_qty: "30",
      },
      {
        vac_itemname: "Packing bag",
        vac_packing: "Nos",
        txt_qty: "2",
      },
    ],
    rows2Con: [
      {
        vac_itemname: "Soda Ash Light",
        vac_packing: "KG",
        txt_qty: "10",
      },
      {
        vac_itemname: "Bittern",
        vac_packing: "KG",
        txt_qty: "20",
      },
      {
        vac_itemname: "Water",
        vac_packing: "L",
        txt_qty: "50",
      },
      {
        vac_itemname: "Fire Wood",
        vac_packing: "KG",
        txt_qty: "30",
      },
    ],
    rowsCount2: 0,
    rowsPerPage2: 50,
    Title: [
      {
        vac_title: "MC Lump",
      },
      {
        vac_title: "Light MC",
      },
    ],
    columns3: [
      { id: "Action", label: "" },
      // { id: "vac_itemname", label: "Item Name", width: 180 },
      {
        id: "vac_itemname",
        label: "Item Name",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 200,
          width: 200,
          items: [
            { vac_itemname: "Light Magnesium Carbonate" },
            { vac_itemname: "Magnesium Carbonate Lump" },
          ],
          colID: "vac_itemname",
          // disabled: this.state.rows3[rowIndex]?.vac_itemname.length > 0,
        },
      },
      {
        id: "vac_packing",
        label: "Packing",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          items: [
            { vac_packing: "KG" },
            { vac_packing: "L" },
            { vac_packing: "CR" },
          ],
          colID: "vac_packing",
        },
      },
      {
        id: "txt_qty",
        label: "Qty",
        type: "CtTxtAmt",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          colID: "txt_qty",
        },
      },
    ],
    rows3: [
      {
        vac_itemname: "Light Magnesium Carbonate",
        vac_packing: "KG",
        txt_qty: "15",
      },
    ],
    rows3FG: [
      {
        vac_itemname: "Magnesium Carbonate Lump",
        vac_packing: "KG",
        txt_qty: "40",
      },
    ],
    rowsCount3: 0,
    rowsPerPage3: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Production Entry";
    this.props.setActiveMenu("ProductionEntry");
  }
  //#endregion Component

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnNewEntryClick = () => {
    if (this.valiadteConsumption()) {
      this.newRowForConsumption();
    }
  };

  handleOnNewEntryFGClick = () => {
    if (this.valiadteFGTable()) {
      this.newRowForFG();
    }
  };

  handleOnRowDataChange2 = (rows2, handledRowIndex, colID) => {
    this.setState({ rows2, rowsCount2: rows2.length });
  };

  handleOnRowDataChange3 = (rows3, handledRowIndex, colID) => {
    this.setState({ rows3, rowsCount3: rows3.length });
  };

  //#endregion Handle

  //#region Function

  newRowForConsumption = (newRows, returnRows) => {
    const rows2 = newRows !== undefined ? newRows : this.state.rows2;
    rows2.push({
      vac_itemname: "",
      int_srno: (this.state.rows2.length + 1).toString(),
    });
    if (returnRows) {
      return rows2;
    } else {
      this.setState({
        rows2,
        rowsCount2: rows2.length,
      });
    }
  };

  valiadteConsumption = () => {
    let errorCount = 0;
    let rows2 = this.state.rows2;
    rows2 = rows2.map((row, index) => {
      errorCount++;
      if (row.vac_itemname.length <= 0) {
        this.props.toastErrorMsg(
          "Enter Data in Consumption Table's Row " + (index + 1)
        );
      } else {
        errorCount--;
      }
    });
    return errorCount === 0;
  };

  newRowForFG = (newRows, returnRows) => {
    const rows3 = newRows !== undefined ? newRows : this.state.rows3;
    rows3.push({
      vac_itemname: "",
      int_srno: (this.state.rows3.length + 1).toString(),
    });
    if (returnRows) {
      return rows3;
    } else {
      this.setState({
        rows3,
        rowsCount3: rows3.length,
      });
    }
  };

  valiadteFGTable = () => {
    let errorCount = 0;
    let rows3 = this.state.rows3;
    rows3 = rows3.map((row, index) => {
      errorCount++;
      if (row.vac_itemname.length <= 0) {
        this.props.toastErrorMsg(
          "Enter Data in Finish Goods Table's Row " + (index + 1)
        );
      } else {
        errorCount--;
      }
    });
    return errorCount === 0;
  };

  SaveProduction = () => {
    if (this.validateProduction()) {
      alert("Save Production");
    }
  };

  deleteProduction = () => {
    alert("Delete Work For Production Is Pending...");
  };

  validateProduction = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (this.state.formData.cmbTitle.length <= 0) {
      this.props.toastErrorMsg("Select Title", "cmbTitle");
    } else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    const dtpDate = "",
      cmbTitle = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpDate,
          cmbTitle,
        },
      },
      () => {
        document.getElementById("dtpDate").focus();
      }
    );
  };

  //#endregion Funtion

  render() {
    let rows =
      this.state.formData.cmbTitle === "MC Lump"
        ? this.state.rows2Con
        : this.state.rows2;
    let rowsFG =
      this.state.formData.cmbTitle === "MC Lump"
        ? this.state.rows3FG
        : this.state.rows3;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b> Production Entry </b>
          </label>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={1}
        >
          <Grid item>
            <CtDtp
              id="dtpDate"
              label="Date*"
              width={170}
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpDate}
              value={this.state.formData.dtpDate}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <label>Production No : 2</label>
          </Grid>

          <Grid item>
            <CtCmbEditable
              id="cmbTitle"
              label="Title"
              items={this.state.Title}
              value={this.state.formData.cmbTitle}
              handleOnChange={this.handleOnChange}
              width={170}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              colID="vac_title"
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            marginTop={1}
          >
            <Grid item>
              <CtBtn label="Save" onClick={this.SaveProduction} />
            </Grid>
            <Grid item>
              <CtBtn label="New" onClick={this.clearInfo} />
            </Grid>
            <Grid item>
              <CtBtn label="Delete" onClick={this.deleteProduction} />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          marginTop={2}
          spacing={2}
        >
          <Grid item lg={6}>
            <label>
              <b>Consumption Table</b>
            </label>
            <TableList
              columns={this.state.columns2}
              rows={rows}
              rowsCount={this.state.rowsCount2}
              rowsPerPage={this.state.rowsPerPage2}
              handleOnNewEntryClick={this.handleOnNewEntryClick}
              //   handleOnActionClick={this.handleARDonActionClick}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              //   actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnRowDataChange={this.handleOnRowDataChange2}
            />
          </Grid>

          <Grid item lg={6}>
            <label>
              <b>Finish Goods Table</b>
            </label>
            <TableList
              columns={this.state.columns3}
              rows={rowsFG}
              rowsCount={this.state.rowsCount3}
              rowsPerPage={this.state.rowsPerPage3}
              handleOnNewEntryClick={this.handleOnNewEntryFGClick}
              //   handleOnActionClick={this.handleARDonActionClick}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              //   actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnRowDataChange={this.handleOnRowDataChange3}
            />
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ProductionEntry2))));
